<se-buttons-toolbar [backVisible]="isBackVisible"
                    [leftSliderOptions]="leftSlider$ | async"
                    [rightSliderOptions]="rightSlider$ | async"
                    [buttonsData]="buttonsDataList$ | async"
                    [disableAll]="disableAll">
</se-buttons-toolbar>
